namespace TotalPoll {
    import Component = TotalCore.Common.Component;

    @Component('components.totalpoll', {
        templateUrl: 'connect-component-template',
        bindings: {}
    })
    class ConnectComponent {

        public positions = [
            {
                value : 'developer',
                label : 'Developer',
                icon  : 'code'
            },
            {
                value : 'webmaster',
                label : 'Webmaster',
                icon  : 'desktop_windows'
            },
            {
                value : 'other',
                label : 'Other',
                icon  : 'person'
            }
        ];

        public usages = [
            {
                value : 'research',
                label : 'Research',
                icon  : 'search'
            },
            {
                value : 'marketing',
                label : 'Marketing',
                icon  : 'shopping_cart'
            },
            {
                value : 'education',
                label : 'Education',
                icon  : 'school'
            },
            {
                value : 'other',
                label : 'Other',
                icon  : 'person'
            }
        ];

        public constructor(private $scope, public OnBoarding) {

        }
    }
}
